import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
export var BooleanFilterOperationType = /*#__PURE__*/ function(BooleanFilterOperationType) {
    BooleanFilterOperationType["IsTrue"] = "IsTrue";
    BooleanFilterOperationType["IsFalse"] = "IsFalse";
    BooleanFilterOperationType["IsEmpty"] = "IsEmpty";
    BooleanFilterOperationType["IsNotEmpty"] = "IsNotEmpty";
    return BooleanFilterOperationType;
}({});
export const BooleanFilterOperationTypes = [
    "IsTrue",
    "IsFalse"
];
export const isOptional = (type)=>type === "IsEmpty" || type === "IsNotEmpty";
// NOTE:: Disabling until a rule is found
const isValid = (_)=>true;
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case "IsEmpty":
        case "IsNotEmpty":
        case "IsTrue":
        case "IsFalse":
            return type;
        default:
            return unreachable(filter.type);
    }
};
const parse = (value, field)=>{
    const type = pascalCase(value);
    switch(type){
        case "IsEmpty":
        case "IsNotEmpty":
        case "IsTrue":
        case "IsFalse":
            return {
                field,
                type
            };
        default:
            return unreachable(type);
    }
};
export const BooleanFieldFilter = {
    isValid,
    toString,
    parse
};
